'use client'

import styles from './premium-filter.module.scss'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import React, { useCallback } from 'react'

type PremiumFilterProps = {
  value?: boolean | undefined
  enabled?: boolean
  onChange?: (value: boolean | undefined) => void
}

const PremiumFilter = ({ value: initialValue, enabled = true, onChange = () => {} }: PremiumFilterProps) => {
  const [value, setValue] = React.useState<boolean | undefined>(initialValue)

  const handleChange = useCallback(
    (updatedValue: boolean | undefined) => {
      setValue(updatedValue)
      onChange(updatedValue)
    },
    [onChange]
  )

  // Watch for changes in the value
  React.useEffect(() => {
    setValue(initialValue)
  }, [initialValue])

  return (
    <div className={styles.main}>
      <Button
        type="button"
        variant="ghost"
        className={cn('tw-w-full !tw-font-light !tw-text-[var(--filter-sidebar-color)]', {
          active: value === false,
        })}
        onClick={() => {
          handleChange(value === false ? undefined : false)
        }}
        disabled={!enabled}
      >
        Show Free
      </Button>
      {/*<Button type="button" variant="ghost" className={cn('tw-flex-1 tw-w-full',{*/}
      {/*  'active': value === true,*/}
      {/*})} onClick={() => {*/}
      {/*  handleChange(value === true ? undefined : true)*/}
      {/*}}>*/}
      {/*  <FaStar className={styles.starIcon} /> Premium*/}
      {/*</Button>*/}
    </div>
  )
}

export { PremiumFilter }
